import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert, { type AlertColor } from '@mui/material/Alert'

interface CustomSnackBarProps {
  message: string
  duration: number
  messageType: AlertColor
  isOpen: boolean
  onClose: (arg: boolean) => void
}

const CustomSnackBar: React.FC<CustomSnackBarProps> = ({ message, duration, messageType, isOpen = false, onClose }): JSX.Element => {
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string): void => {
    if (reason === 'clickaway') {
      return
    }
    onClose(false)
  }

  return (
    <Snackbar open={isOpen} autoHideDuration={duration} onClose={handleClose}>
      <MuiAlert elevation={6} variant="outlined" onClose={handleClose} severity={messageType} sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {message}
      </MuiAlert>
    </Snackbar>
  )
}

export default CustomSnackBar
